/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
// import { Link as MuiLink } from 'react-router-dom';
import {
  Box,
  Tabs,
  Tab,
  Container,
  Stack,
  Typography,
  Breadcrumbs,
  Link as MuiLink,
  Paper,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectUserId } from 'renderer/features/auth/state/userSelectors';
import GeneralTab from './GeneralTab';
import BillingTab from './BillingTab';
import SecurityTab from './SecurityTab';

const Settings = () => {
  const [currentTab, setCurrentTab] = useState('general');

  // const user = useAppSelector(selectUser);
  // const userId = user.role === 'public' ? '' : user._id;
  const userId = useAppSelector(selectUserId);

  const renderTabContent = () => {
    switch (currentTab) {
      case 'general':
        return <GeneralTab />;
      case 'billing':
        return <BillingTab />;
      case 'security':
        return <SecurityTab userId={userId ?? ''} />;
      default:
        return null;
    }
  };

  const handleTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: 'general' | 'billing' | 'security',
  ) => {
    setCurrentTab(newValue);
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        // py: 8,
      }}
    >
      <Container>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <MuiLink underline="hover" color="inherit" href="/#">
            Home
          </MuiLink>
          <Typography color="text.primary">Settings</Typography>
        </Breadcrumbs>
        <Typography variant="h4" gutterBottom sx={{ mb: 2 }}>
          Settings
        </Typography>
        <Grid
          container
          disableEqualOverflow
          spacing={{
            xs: 3,
            lg: 4,
          }}
        >
          <Grid xs={12}>
            <Stack direction="row" justifyContent="space-between" spacing={4} />
          </Grid>
        </Grid>
        <Grid xs={12}>
          <Box sx={{ py: 1 }}>
            <Tabs value={currentTab} onChange={handleTabChange}>
              <Tab label="General" value="general" />
              <Tab label="Billing" value="billing" />
              <Tab label="Security" value="security" />
            </Tabs>
            <Box sx={{ mt: 3, border: 'none' }}>
              <Paper elevation={0} sx={{ p: 0 }}>
                {renderTabContent()}
              </Paper>
            </Box>
          </Box>
        </Grid>
      </Container>
    </Box>
  );
};

export default Settings;
